import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Braces, AlertTriangle, CalendarClock } from "lucide-react";
import { api, formatMoney } from "@/lib/api";
import { fmtDate } from "@/lib/ortho";

export default function OrthoAlerts() {
  const [ov, setOv] = useState(null);
  useEffect(() => { api.get("/ortho/overview").then((r) => setOv(r.data)).catch(() => {}); }, []);
  if (!ov || ov.active_cases === 0) return null;
  const hasAlerts = ov.overdue_installments.length > 0 || ov.no_control.length > 0;
  return (
    <section className={`card-flat p-4 sm:p-5 border-l-4 ${hasAlerts ? "border-l-destructive" : "border-l-primary"}`} data-testid="ortho-alerts">
      <div className="flex items-start gap-3">
        <Braces className="w-5 h-5 text-primary mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-sm">Ortodoncia · {ov.active_cases} caso(s) activo(s)</div>
          {!hasAlerts && <div className="text-sm text-muted-foreground">Sin cuotas vencidas ni controles atrasados.</div>}
          {ov.overdue_installments.length > 0 && (
            <div className="mt-2">
              <div className="text-xs font-bold text-destructive flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5" /> {ov.overdue_installments.length} cuota(s) vencida(s)</div>
              <ul className="text-sm text-muted-foreground mt-1 space-y-0.5">
                {ov.overdue_installments.slice(0, 5).map((i) => (
                  <li key={i.id}><Link to={`/pacientes/${i.patient_id}`} className="text-primary font-semibold hover:underline">{i.patient_name}</Link> · {i.label} · {formatMoney(i.amount)} · venció {fmtDate(i.due_date)}</li>
                ))}
              </ul>
            </div>
          )}
          {ov.no_control.length > 0 && (
            <div className="mt-2">
              <div className="text-xs font-bold text-accent flex items-center gap-1"><CalendarClock className="w-3.5 h-3.5" /> {ov.no_control.length} paciente(s) sin control hace más de 45 días</div>
              <ul className="text-sm text-muted-foreground mt-1 space-y-0.5">
                {ov.no_control.slice(0, 5).map((c) => (
                  <li key={c.case_id}><Link to={`/pacientes/${c.patient_id}`} className="text-primary font-semibold hover:underline">{c.patient_name}</Link> · último control {fmtDate(c.last_control_date)}{c.phone ? ` · ${c.phone}` : ""}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
